<template>
  <h2 class="titleStepForm">Member's Declaration</h2>
  <div class="">
    <p class="font-weight-500">
      Eastern Credit Union Cooperative Society Limited is
      required to comply with Anti- Money laundering and
      Combating Terrorist Financing legislation (Proceeds of
      Crime Act and Financial Obligations Regulations,
      Financial Intelligence Unit) and the Foreign Account Tax
      Compliance Act
    </p>
    <label
      for="hereByRd"
      class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
      :class="{
        'is-invalid': v$.form.personal.hereRadioType.$error,
      }"
    >
      <input
        type="checkbox"
        v-model="form.personal.hereRadioType"
        value="true"
        class="inputRadioCstm d-none"
        id="hereByRd"
      />
      <span class="radioCircleIcon line-height-1">
        <i
          class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
        ></i>
        <i
          class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
        ></i>
      </span>
      <h4
        class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
      >
        I hereby apply for membership in
        <strong class="font-weight-500"
          >Eastern Credit Union Cooperative Society
          Limited</strong
        >
        and declare that the information given in this
        Membership Application Form is true and correct.
      </h4>
    </label>
    <div
      v-for="(personal, index) in v$.form.personal
        .hereRadioType.$errors"
      :key="index"
      class="invalid-feedback"
    >
      <span v-if="personal.$message">{{
        personal.$message
      }}</span>
    </div>
    <p>
      I agree to abide by the terms of the account(s)
      agreement and with the Statutory Provision and bye-laws
      governing the operations of
      <strong class="font-weight-500"
        >Eastern Credit Union Cooperative Society
        Limited.</strong
      >
      I am also aware that I am not a bona fide member of the
      credit union until this application is approved by the
      Board.
    </p>
  </div>
  <div class="">
    <div
      :class="
        radioSelected1 === 'minor' ? 'border-bottom' : ''
      "
      class="pb-3 mb-3"
    >
      <div class="row">
        <div class="col-lg-6 mb-3">
          <div class="d-block">
            <label class="font-size-14"
              >Applicant’s Name
              <sup>(Block Letters)</sup></label
            >
            <input
              type="text"
              v-model="form.personal.appliname"
              class="form-control"
              placeholder="Applicant Name"
              disabled
            />
            <!-- Optional validation: appliname -->
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="form-group">
            <label for="my-file">Applicant’s Signature</label>
            <div>
              <a
                v-if="imageUrl_six"
                :href="imageUrl_six"
                target="_blank"
              >
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
              </a>
              <div v-else>
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <div>No Document found</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <template v-if="radioSelected1 === 'minor'">
    <div class="border-bottom pb-3 mb-3">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <div class="d-block">
            <label class="font-size-14"
              >Name of Parent/Guardian</label
            >
            <input
              type="text"
              class="form-control"
              v-model="form.personal.nameofparent"
              placeholder="Name of Parent/Guardian"
              disabled
            />
          </div>
        </div>

        <div class="col-lg-6 mb-3">
          <div class="form-group">
            <label for="my-file"
              >Parent/ Guardian’s Signature
              <sup>(for minors)</sup></label
            >
            <div>
              <a
                v-if="imageUrl_seven"
                :href="imageUrl_seven"
                target="_blank"
              >
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
              </a>
              <div v-else>
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <div>No Document found</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pb-3 mb-3">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <div class="d-block">
            <label class="font-size-14"
              >Name of Trustee</label
            >
            <input
              type="text"
              class="form-control"
              v-model="form.personal.nameoftrustee"
              placeholder="Name of Trustee"
              disabled
            />
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="form-group">
            <label for="my-file"
              >Trustee’s Signature
              <sup>(for minors)</sup></label
            >
            <div>
              <a
                v-if="imageUrl_eight"
                :href="imageUrl_eight"
                target="_blank"
              >
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
              </a>
              <div v-else>
                <i
                  class="mdi mdi-file-document-multiple font-size-24 text-theme"
                ></i>
                <div>No Document found</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <!-- Optional validation: appliname8 -->
  <!-- Optional validation: datename8 -->
</template>

<script>
import { bridge } from "../formBridge";

export default {
  name: "ReviewDeclaration",
  props: {
    variant: { type: String, default: "review" },
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
  },
  mixins: [
    bridge({
    state: ["imageUrl_six", "imageUrl_seven", "imageUrl_eight", "radioSelected1", "form"],
    validate: true,
    }),
  ],
};
</script>
